import { render } from "./Church.vue?vue&type=template&id=def305bc"
import script from "./Church.vue?vue&type=script&lang=js"
export * from "./Church.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__